var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu-content" }, [
    _c(
      "div",
      {
        staticClass: "menu-list",
        on: {
          mouseleave: function($event) {
            return _vm.onMouseOut("list")
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "item current-item",
            style: {
              background:
                _vm.activeItem === 0 ? _vm.activeColor : _vm.normalColor
            },
            on: {
              mouseenter: function($event) {
                return _vm.onMouseOver(0)
              },
              mouseleave: function($event) {
                return _vm.onMouseOut(0)
              },
              click: function($event) {
                return _vm.onActiveClick()
              }
            }
          },
          [_vm._v(_vm._s(_vm.dictionary[_vm.menulist[0]]) + "\n    ")]
        ),
        _vm._v(" "),
        _vm._l(_vm.menulist, function(item, index) {
          return _c(
            "div",
            {
              key: item,
              staticClass: "hidden-items",
              style: { display: _vm.isOpen ? "block" : "none" }
            },
            [
              index !== 0
                ? _c(
                    "div",
                    {
                      staticClass: "item another-item",
                      style: {
                        background:
                          _vm.activeItem === index
                            ? _vm.activeColor
                            : _vm.normalColor
                      },
                      on: {
                        mouseenter: function($event) {
                          return _vm.onMouseOver(index)
                        },
                        mouseleave: function($event) {
                          return _vm.onMouseOut(index)
                        },
                        click: function($event) {
                          return _vm.onNormalClick(item, index)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.dictionary[item]) + "\n      ")]
                  )
                : _vm._e()
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a81f2a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a81f2a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DbMenu.vue
// module id = null
// module chunks = 